import { ca } from '@cian/analytics';

import { createDeveloperProduct } from 'shared/utils/analytics';

/**
 * @description Событие: блок «О компании» попал в зону видимости.
 */
export function trackShowAboutSection(): void {
  ca('eventSite', {
    action: 'show_landing_section',
    category: 'Promo',
    label: 'about',
    name: 'oldevent',
    products: [createDeveloperProduct()],
  });
}
